import { SET_CURRENT_USER, UPDATE_CURRENT_USER, SET_LANG, SET_ADDRESS, SET_PAYMENT, SHOW_ORDER, SHOW_BRANDS } from "./user.type"



export const setCurrentUser = user => ({
    type : SET_CURRENT_USER,
    payload : user
})

export const showOrderList = () => ({
    type : SHOW_ORDER,
})

export const setBrandsList = (list) => ({ 
    type : SHOW_BRANDS,
    payload : list
})

export const setAddressUser = address => ({
    type : SET_ADDRESS,
    payload : address
})

export const setPaymentUser = payment => ({
    type : SET_PAYMENT,
    payload : payment
})

export const updateCurrentUser = user => ({
    type : UPDATE_CURRENT_USER,
    payload : user
})

export const setCurrentLang = user => ({
    type : SET_LANG,
    payload : user
})